import { Plus } from 'react-bootstrap-icons';
import { CareMapprTextarea } from '../../../../../components/Inputs/textarea';
import { LetterType } from '../PharmacistDoctorLetterSection';
import { useLettersForm } from '../provider/LettersFormContext';
import CareMapprButton from '../../../../../components/Button/CareMapprButton';
import CareMapprIconButton from '../../../../../components/Button/CareMapprIconButton';
import TrashIcon from '../../../../../../assets/img/button-icons/trash-red.svg';
import { useMedicationProfileDirty } from '../../../context/MedicationProfileDirtyProvider';

interface SummaryRecommandationProps {
  type: LetterType;
}

const SummaryRecommandation = ({ type }: SummaryRecommandationProps) => {
  const { pharmacistLetterForm, doctorLetterForm } = useLettersForm();
  const { setIsDirty } = useMedicationProfileDirty();
  const recommandations =
    type === LetterType.PHARMACIST
      ? pharmacistLetterForm.getValues().summaryOfRecommendations || ['']
      : doctorLetterForm.getValues().summaryOfRecommendations || [''];
  return (
    <div className="letters-form-add-item">
      <div className="d-flex flex-column align-items-start gap-2">
        <label>Summary of recommendations</label>
        {recommandations.map((recommendation, index) => {
          return (
            <div
              key={`recomm-${index}`}
              className="width-100-percent d-flex align-items-end gap-2"
            >
              <CareMapprTextarea
                autoResize
                key={`recomm-${index}`}
                placeholder="Start typing..."
                value={recommendation}
                className="flex-grow-1 width-100-percent"
                inputClassName="w-100"
                onChange={(e) => {
                  setIsDirty(true);
                  if (type === LetterType.PHARMACIST) {
                    pharmacistLetterForm.setValue(
                      `summaryOfRecommendations.${index}`,
                      e.target.value,
                      { shouldDirty: true },
                    );
                  } else {
                    doctorLetterForm.setValue(
                      `summaryOfRecommendations.${index}`,
                      e.target.value,
                      { shouldDirty: true },
                    );
                  }
                }}
              />
              {recommandations.length > 1 && (
                <CareMapprIconButton
                  className="m-0 width-70 min-width-0"
                  icon={
                    <img src={TrashIcon} className="icon" alt="edit pen icon" />
                  }
                  onClick={() => {
                    const updated = recommandations.filter(
                      (_, i) => i !== index,
                    );
                    if (type === LetterType.PHARMACIST) {
                      pharmacistLetterForm.setValue(
                        `summaryOfRecommendations`,
                        updated,
                        { shouldDirty: true },
                      );
                    } else {
                      doctorLetterForm.setValue(
                        `summaryOfRecommendations`,
                        updated,
                        { shouldDirty: true },
                      );
                    }
                  }}
                />
              )}
            </div>
          );
        })}
        <CareMapprButton
          extraClassNames="ms-auto m-0 width-120 ps-0"
          labelClassName="add-line-button"
          type="button"
          variant="link"
          label="Add line"
          startIcon={<Plus size={20} color="#6b6964" />}
          style={{ textDecoration: 'none' }}
          onClick={() => {
            if (type === LetterType.PHARMACIST) {
              pharmacistLetterForm.setValue(
                `summaryOfRecommendations.${recommandations.length}`,
                '',
                { shouldDirty: true },
              );
            } else {
              doctorLetterForm.setValue(
                `summaryOfRecommendations.${recommandations.length}`,
                '',
                { shouldDirty: true },
              );
            }
          }}
        />
      </div>
    </div>
  );
};

export default SummaryRecommandation;
